module.exports = __webpack_public_path__ + "static/media/photoActive.dd4e4b33.svg";